import React from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'
import { isEmpty } from 'lodash-es'

// Libs
import { fetchProductList } from '@/api/fetchProductList'
import { fetchMerchantInfo } from '@/api/fetchMerchantInfo'
import { useProductData } from '@/hooks/useProductData'
import { useCategoryMenu } from '@/hooks/useCategoryMenu'
import { useLiveData } from '@/hooks/useLiveData'
import useMedia from '@/hooks/useMedia'
import { isLiveMallClub } from '@/constants/systemType'

// Components
import InvalidProduct from './component/InvalidProduct'
import ValidProduct from './component/ValidProduct'
import ProductSkeleton from './skeleton/ProductSkeleton'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

// Styles

enum ProductStatus {
  OnShelf = 100,
  OffShelf = 2,
  Delete = 1,
}

const DESKTOP_RECOMMENDATION_PRODUCT_TOTAL_NUMBER = 6
const MOBILE_RECOMMENDATION_PRODUCT_TOTAL_NUMBER = 3

const Product = (props: any) => {
  const { productDataSSR } = props
  const { isTablet, isMobile } = useMedia()
  const router = useRouter()
  const { query } = router

  const productData = useProductData(query?.id, productDataSSR)

  // 提前並行請求麵包屑用的分類樹，避免等商品資料回來、Breadcrumb 掛載後才發出（request waterfall）
  useCategoryMenu({ enabled: !isLiveMallClub })
  const { productInfo, productDataIsFetched, isShowProduct } = productData
  const { isLive, roomId, isMerchantLive, liveData, liveProductInfo, liveMerchantInfo } = useLiveData({
    productId: query.id as string,
    merchantId: productInfo?.merchantId,
  })

  const { data: productList } = useQuery(
    [QUERY_KEY.FETCH_PRODUCT_LIST, { queryId: query.id }],
    () => fetchProductList({ merchantId: productInfo.merchantId ? productInfo.merchantId : '1', size: 7 }),
    { enabled: !!productInfo?.merchantId },
  )
  const { data: merchantInfo } = useQuery(
    [QUERY_KEY.FETCH_MERCHANT_INFO, {}],
    () => fetchMerchantInfo({ merchantId: productInfo.merchantId ? productInfo.merchantId : '1' }),
    { enabled: !!productInfo?.merchantId },
  )
  //只有前六筆數 且不該有自己 並且是上架商品
  const merchantProductList = productList?.productsInfo
    ?.filter((data: any) => data.productId !== Number(query.id))
    .filter((data: any) => data.status === ProductStatus.OnShelf)
    .slice(0, isTablet || isMobile ? MOBILE_RECOMMENDATION_PRODUCT_TOTAL_NUMBER : DESKTOP_RECOMMENDATION_PRODUCT_TOTAL_NUMBER)

  // product 的 status -> 有沒有送審(有效或無效)
  // sku 的 status -> 有沒有啟用
  // status 因為後台多了送審機制，主要是給送審判斷用
  // 前端單純判斷 isShow
  const isInValidProduct =
    isEmpty(productInfo) || !isShowProduct || productInfo?.status === ProductStatus.OffShelf || productInfo?.status === ProductStatus.Delete

  return (
    <>
      {!productDataIsFetched ? (
        <ProductSkeleton />
      ) : isInValidProduct ? (
        <InvalidProduct merchantProductList={merchantProductList} merchantInfo={merchantInfo} liveData={liveData} />
      ) : (
        <ValidProduct
          productList={productList}
          merchantInfo={merchantInfo}
          merchantProductList={merchantProductList}
          productData={productData}
          liveProductInfo={liveProductInfo}
          liveMerchantInfo={liveMerchantInfo}
          isLive={isLive}
          roomId={roomId}
          isMerchantLive={isMerchantLive}
          liveData={liveData}
        />
      )}
    </>
  )
}

export default Product
